import { render, staticRenderFns } from "./RoleMagicLinkAuth.vue?vue&type=template&id=46dec396&scoped=true"
import script from "./RoleMagicLinkAuth.vue?vue&type=script&lang=js"
export * from "./RoleMagicLinkAuth.vue?vue&type=script&lang=js"
import style0 from "./RoleMagicLinkAuth.vue?vue&type=style&index=0&id=46dec396&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46dec396",
  null
  
)

export default component.exports